// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YhJe","requiredAsterisk":"Info_requiredAsterisk__3A-xT"};